import React from 'react'

type Props = {
    title?: string
    className?: string
}

const DefaultStarIcon: React.FC<Props> = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.41179 17.4278L12 15.2639L15.5882 17.4563L14.6484 13.3562L17.8095 10.6228L13.6517 10.2527L12 6.38033L10.3483 10.2242L6.19052 10.5943L9.35156 13.3562L8.41179 17.4278ZM5.82036 21L7.45234 13.9738L2 9.24956L9.19388 8.62537L12 2L14.8061 8.62537L22 9.24956L16.5477 13.9738L18.1796 21L12 17.2723L5.82036 21Z"
            fill="#282E37"
        />
    </svg>
)

export default DefaultStarIcon
